module.exports = "<div *ngIf=\"widget\">\n  <a href=\"{{widget.previewUrl}}\" target=\"_preview\">{{widget.previewUrl}}</a>\n  <button type=\"button\" ngxClipboard [cbContent]=\"widget.previewUrl\" (cbOnSuccess)=\"isCopied1 = true\"\n          class=\"btn btn-secondary\">\n    <clr-icon shape=\"clipboard\"></clr-icon>\n    Kopiera\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-dashboard/widget-detail-dashboard.component.html
// module id = ./src/app/widgets/widget-detail/widget-detail-dashboard/widget-detail-dashboard.component.html
// module chunks = main